module.exports = __webpack_public_path__ + "img/laptop.bb11b97f.svg";